import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';

export default function KPICard({ spec }) {
  const { title, value, raw_value, unit, subtitle, sparkline } = spec;
  
  // Calculate trend if sparkline data is available
  const getTrend = () => {
    if (!sparkline || !sparkline.data || sparkline.data.length < 2) return null;
    
    const firstValue = sparkline.data[0];
    const lastValue = sparkline.data[sparkline.data.length - 1];
    
    if (lastValue > firstValue) return 'up';
    if (lastValue < firstValue) return 'down';
    return 'flat';
  };
  
  const trend = getTrend();
  
  return (
    <Card sx={{ 
      maxWidth: 300, 
      mx: 'auto', 
      my: 2,
      backgroundColor: 'background.paper',
      boxShadow: 1,
      borderRadius: 2,
      '&:hover': {
        boxShadow: 2
      }
    }}>
      <CardContent>
        {subtitle && (
          <Typography variant="caption" color="text.secondary" gutterBottom sx={{ display: 'block', mb: 1 }}>
            {subtitle}
          </Typography>
        )}
        <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5 }}>
          {unit && unit !== '$' && (
            <Typography variant="h6" color="text.secondary">
              {unit}
            </Typography>
          )}
          <Typography 
            variant="h3" 
            component="div" 
            sx={{ 
              color: 'primary.main',
              fontWeight: 600,
              fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' }
            }}
          >
            {value}
          </Typography>
        </Box>
        {sparkline && trend && (
          <Box sx={{ mt: 2, display: 'flex', alignItems: 'center', gap: 0.5 }}>
            {trend === 'up' && <TrendingUpIcon color="success" fontSize="small" />}
            {trend === 'down' && <TrendingDownIcon color="error" fontSize="small" />}
            {trend === 'flat' && <TrendingFlatIcon color="action" fontSize="small" />}
            <Typography variant="caption" color="text.secondary">
              vs previous period
            </Typography>
          </Box>
        )}
        {title && (
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
            {title}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
}